// @ts-ignore
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { QuestionnaireFragmentDoc } from '../../../components/cms/component/questionnaire/Questionnaire.fragment.generated';
import * as Urql from '@urql/vue';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const QuestionnaireDocument = gql`
    query questionnaire($id: ID!, $locale: Locale!, $currency: CurrencyInput!, $region: RegionCode!) {
  questionnaire(id: $id) {
    ...questionnaire
  }
}
    ${QuestionnaireFragmentDoc}`;

export function useQuestionnaireQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.QuestionnaireQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.QuestionnaireQuery, SchemaTypes.QuestionnaireQueryVariables | undefined>({ query: QuestionnaireDocument, variables: undefined, ...options });
};